/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyday, math and money calculators.`)
};

const es_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras cotidianas, matemáticas y financieras.`)
};

const de_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alltags-, Mathe- und Finanzrechner.`)
};

const nl_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alledaagse, wiskundige en financiële rekenmachines.`)
};

const fr_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrices du quotidien, mathématiques et financières.`)
};

const it_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatori quotidiani, matematici e finanziari.`)
};

const pt_br2_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras do dia a dia, de matemática e de dinheiro.`)
};

const pt_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras do dia a dia, de matemática e de dinheiro.`)
};

const ja_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常、数学、お金の計算機。`)
};

const zh_cat_calculators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常、数学和理财计算器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_calculators_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_calculators_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_calculators_desc", locale)
	if (locale === "en") return en_cat_calculators_desc(inputs)
	if (locale === "es") return es_cat_calculators_desc(inputs)
	if (locale === "de") return de_cat_calculators_desc(inputs)
	if (locale === "nl") return nl_cat_calculators_desc(inputs)
	if (locale === "fr") return fr_cat_calculators_desc(inputs)
	if (locale === "it") return it_cat_calculators_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_calculators_desc(inputs)
	if (locale === "pt") return pt_cat_calculators_desc(inputs)
	if (locale === "ja") return ja_cat_calculators_desc(inputs)
	return zh_cat_calculators_desc(inputs)
};